import type { Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { docEntityIsSystemEntity } from "./docSystemEntity";
import { docEntityHandleToEntityRef } from "./entity/docEntityHandleToEntityRef";

export function docEntityIsRenameable(doc: Doc, handle: DocEntityHandle): boolean {
  const entityRef = docEntityHandleToEntityRef(doc, handle);

  if (entityRef) {
    return false;
  }

  if (docEntityIsSystemEntity(doc, handle)) {
    return false;
  }

  switch (handle.type) {
    case "ROOF_SIDE":
    case "EDGE":
    case "VERTEX":
    case "AUTO_DIMENSION":
    case "ELEVATION_VIEW":
    case "OPTION_EFFECT":
    case "ENTITY_SETTINGS":
    case "SETTINGS":
    case "GENERATED_ENTITY":
    case "SELECTOR":
    case "VIEW_SELECTOR":
    case "EDIT_MODE":
    case "DOC_REF":
    case "RULE_BASED_SELECTOR_INSTANCE":
    case "SYSTEM_PARAMETER":
      return false;

    default:
      return true;
  }
}
